import React, { useState, useEffect } from "react";

// @material-ui/core components
import Box from "@mui/material/Box";
import TextField from '@mui/material/TextField';
import Modal from "@mui/material/Modal";
import Typography from '@mui/material/Typography';
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize';

// costumize component
import Button from "components/CustomButtons/Button.js";

// mui tel-input
import { MuiTelInput } from 'mui-tel-input'

// utils 
import { styleBox } from '../../../../utils/views/style'

// apis
import { bulkDeleteBusTypeApi, deleteBusTypeApi, updateBusTypeApi } from '../../../../apis/bus';

const stylesField = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(stylesField);

// eslint-disable-next-line react/prop-types
const BasicModal = ({ open, modal, modalData, setOpen, setReloadData }) => {
  // variable
  const [busTypeName, setBusTypeName] = useState('')
  const [busTypeCode, setBusTypeCode] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [phone, setPhone] = useState(0)
  const [selectCity, setSelectCity] = useState(0)
  const [errorForeignMessage, setErrorForeignMessage] = useState([])
  const [btnDelete, setBtnDelete] = useState(false)
  
  // methods
  const handleClose = () => {
    setOpen(false);
    if (modal == 'bulkDelete') setReloadData()
  }

  const handleUpdateBusType = async (event) => {
    try {
      event.preventDefault()
      setErrorMessage('')
      let response = await updateBusTypeApi(modalData.id, { code: busTypeCode, label: busTypeName, totalSeat: modalData.totalSeat })
      setReloadData()
    } catch (error) {
      if (error.response.data.errors.message) {
        setErrorMessage(error.response.data.errors.message)
      } else {
        setErrorMessage(error.response.data.errors[0].message)
      }
    }
  }

  const handleDeleteBusType = async () => {
    try {
      setErrorMessage('')
      let response = await deleteBusTypeApi(modalData.id)
      setReloadData()
    } catch (error) {
      setErrorMessage(error.response.data.errors[0].message)
      setBtnDelete(true)
    }
  }

  const bulkDelete = async () => {
    try {
      let response = await bulkDeleteBusTypeApi({ ids: modalData })
      setReloadData()
    } catch (error) {
      console.log(error)
      setErrorMessage(error.response.data.errors[0].message)
      setBtnDelete(true)
      // if (error.response.data.data.agents) setErrorForeignMessage(error.response.data.data.agents)
    }
  }

  const classes = useStyles();

  useEffect(() => {
    if (modal != 'add') {
      setBusTypeName(modalData.label)
      setBusTypeCode(modalData.code)
    }
  }, []);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {
          modal != 'delete' && modal != 'bulkDelete' ?
            <Box sx={{ ...styleBox, width: 400 }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                {modal == 'update' ? 'Update Tipe Bus' :''}
              </Typography>
              <Box fullWidth>
                <form onSubmit={handleUpdateBusType}>
                  <TextField
                    value={busTypeName}
                    onChange={e => setBusTypeName(e.target.value)}
                    id="busType"
                    label="Nama Tipe Bus"
                    autoComplete="busTypeLabel"
                    margin="normal"
                    fullWidth
                    required
                  />
                  <TextField
                    value={busTypeCode}
                    onChange={e => setBusTypeCode(e.target.value)}
                    id="busTypeCode"
                    label="Kode Tipe Bus"
                    autoComplete="busTypeCode"
                    margin="normal"
                    fullWidth
                    required
                  />
                  <center>
                    <p>{errorMessage}</p>
                  </center>
                  <Box display="flex" justifyContent="end">
                    <Button
                      color="outline"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      type="submit"
                    >
                      {modal == 'add' ? 'Tambah' : 'Update'}
                    </Button>
                  </Box>
                </form>
              </Box>
            </Box>
            : modal == 'bulkDelete' ?
              <Box sx={{ ...styleBox, width: 400 }}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Apakah Anda ingin menghapus Tipe Bus dengan ID {
                    modalData.map((item) => (
                      <span> {item}, </span>
                    ))
                  } ?
                </Typography>
                <center>
                  <p>{errorMessage}</p>
                  {
                    errorForeignMessage.length > 0 ?
                      <p>List City:</p>
                      : null
                  }
                  {
                    errorForeignMessage.map((item) => (
                      <span>{item.label}, </span>
                    ))
                  }
                </center>
                <Box display="flex" justifyContent="end">
                  <Button
                    color="outline"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  {
                    !btnDelete ?
                      <Button
                        color="primary"
                        onClick={bulkDelete}
                      >
                        Delete
                      </Button>
                      : ''
                  }
                </Box>
              </Box>
            :
            <Box sx={{ ...styleBox, width: 400 }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Apakah Anda ingin menghapus Tipe Bus <span>{busTypeName}</span> ?
              </Typography>
              <center>
                <p>{errorMessage}</p>
              </center>
              <Box display="flex" justifyContent="end">
                <Button
                  color="outline"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                {
                  !btnDelete ?
                    <Button
                      color="primary"
                      onClick={handleDeleteBusType}
                    >
                      Delete
                    </Button>
                    : ''
                }
              </Box>
            </Box>
        }

      </Modal>
    </div>
  );
};

export default BasicModal;
